export const homeFaqs = [
  {
    q: "Where exactly is Finca Cortesín?",
    a: "Finca Cortesín sits on the coast of Casares, Málaga province, in southern Spain. The resort is reached in 35 minutes from Marbella, 50 minutes from Málaga International Airport and 35 minutes from Gibraltar International Airport.",
  },
  {
    q: "How many new developments are currently available?",
    a: "There are eleven active new-build releases inside or directly adjacent to the resort, spanning apartments, penthouses, branded residences, frontline golf villas, sea-view villas and serviced bespoke villa plots.",
  },
  {
    q: "What is the price range across the developments?",
    a: "Entry pricing starts at €668,250 for a Lake Essence villa plot and rises to over €4.5 million for the top-floor penthouses at the branded St. Regis and Missoni residences. Most apartments sit in the €1 – 2 million bracket; villas €2.7 – 4 million.",
  },
  {
    q: "Can non-residents in Spain buy property here?",
    a: "Yes. Foreign buyers face no restrictions on purchasing Spanish real estate. You will need an NIE (foreigner's tax number) and a Spanish bank account, both of which we can help arrange.",
  },
  {
    q: "What does the buying process look like?",
    a: "Reservation deposit, contract signing, staged payments protected by bank guarantee, then completion at Notary. Total transaction costs typically add 11 – 13% on top of the headline price.",
  },
  {
    q: "Are these developments suitable as rental investments?",
    a: "Several — particularly the branded Marea by Missoni and St. Regis Residences — qualify for a managed rental programme that delivers strong short-term yields with full management. We can model expected returns for any specific unit on request.",
  },
];

export const buyerGuideSteps = [
  {
    number: "01",
    title: "Discovery & shortlist",
    body:
      "We send you the current price list and availability across all eleven developments. You shortlist 2 – 3 candidates based on view, budget and timing.",
  },
  {
    number: "02",
    title: "Private viewing",
    body:
      "Our local advisor meets you at the resort. We tour shortlisted units, the championship course, the beach club and the resort spa.",
  },
  {
    number: "03",
    title: "Reservation",
    body:
      "A reservation deposit (€6,000 – €30,000) holds your chosen unit. A bilingual lawyer reviews the contract before signature.",
  },
  {
    number: "04",
    title: "Contract & staged payments",
    body:
      "Sign the contract with 15 – 20% down. Subsequent payments are tied to construction milestones and protected by bank guarantee.",
  },
  {
    number: "05",
    title: "Completion & handover",
    body:
      "Final balance is paid at the Notary against the deed of sale. Keys, snagging walk-through and owners' onboarding follow within days.",
  },
];

export const lifestylePillars = [
  {
    key: "golf",
    title: "Championship Golf",
    body:
      "Host of the 2023 Solheim Cup. A Cabell Robinson masterpiece of 6,800 metres with bent-grass greens kept to tournament condition year-round.",
    image: "https://images.pexels.com/photos/17383426/pexels-photo-17383426.jpeg",
  },
  {
    key: "spa",
    title: "2,200 m² Spa",
    body:
      "One of southern Europe's largest hotel spas: heated pools, Schletterer thermal circuit, snow room, and treatment menus by Bamford and Natura Bissé.",
    image: "https://images.pexels.com/photos/3757640/pexels-photo-3757640.jpeg",
  },
  {
    key: "beach-club",
    title: "Private Beach Club",
    body:
      "A six-minute shuttle ride delivers residents to a quiet stretch of Casares coastline — two pools, two restaurants, direct sand access.",
    image: "https://images.pexels.com/photos/21856217/pexels-photo-21856217.jpeg",
  },
  {
    key: "dining",
    title: "Michelin-Starred Dining",
    body:
      "Don Giovanni holds a Michelin star for its modern Italian cuisine. Add the resort's Andalusian garden restaurant and beach kitchen for variety.",
    image: "https://images.pexels.com/photos/29962487/pexels-photo-29962487.jpeg",
  },
  {
    key: "hotel",
    title: "Five-Star Hotel",
    body:
      "The 67-room Hotel Finca Cortesín — a member of Leading Hotels of the World — provides full hospitality services to resort homeowners.",
    image: "https://images.pexels.com/photos/9976125/pexels-photo-9976125.jpeg",
  },
  {
    key: "privacy",
    title: "Absolute Privacy",
    body:
      "A 215-hectare gated estate with 24-hour security, low-density planning and protected cork-oak forest preserves a profound sense of seclusion.",
    image: "https://images.unsplash.com/photo-1629199159634-28a88785cee5",
  },
];

export const whyBuyPoints = [
  {
    title: "Inside a five-star resort",
    body:
      "Every residence sits within the gates of one of Europe's most awarded private resorts — concierge, security and amenities included.",
  },
  {
    title: "Championship golf",
    body:
      "Host of the Solheim Cup 2023 and three Volvo World Match Plays. A genuine tournament-grade course on your doorstep.",
  },
  {
    title: "Brand pedigree",
    body:
      "Missoni, St. Regis and Leading Hotels of the World combine to elevate the resort's standing in the global luxury market.",
  },
  {
    title: "Capital growth potential",
    body:
      "Casares Costa pricing has outperformed neighbouring micro-markets every year since 2019. Branded units lead the trend.",
  },
  {
    title: "Just 50 minutes from Málaga",
    body:
      "Two international airports within an hour. Marbella, Sotogrande and Estepona all reachable in under forty minutes by car.",
  },
  {
    title: "Andalusian climate",
    body:
      "320 days of sun, mild winters and the unique microclimate created by the sheltering Sierra Bermeja behind the resort.",
  },
];
